export const saveStoreUser = (data) => ({
    type: 'USER_SAVE',
    data: data
})

export const deleteStoreUser = () => ({
    type: 'USER_DELETE'
})